import { render, staticRenderFns } from "./agb.vue?vue&type=template&id=500f093e&scoped=true&"
import script from "./agb.vue?vue&type=script&lang=js&"
export * from "./agb.vue?vue&type=script&lang=js&"
import style0 from "./agb.vue?vue&type=style&index=0&id=500f093e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500f093e",
  null
  
)

export default component.exports